import { jsx as t, jsxs as B } from "react/jsx-runtime";
import { useState as e, useEffect as S } from "react";
import { getCoupons as E } from "./api/getCoupons.js";
import { LoadingView as G } from "./views/LoadingView.js";
import { CouponsView as H } from "./views/CouponsView.js";
import { RulesView as K } from "./views/RulesView.js";
import { OverwriteView as P } from "./views/OverwriteView.js";
import { EmptyCartView as Q } from "./views/EmptyCartView.js";
/* empty css                                             */const I = ({
  orderFormId: h,
  hasItemsInCart: a,
  builder: j,
  account: f,
  isIO: o = !1,
  closeIOModal: r,
  activeOrderFormCoupon: n,
  genericTaggingEvent: s,
  disableFirstEmptyModal: A,
  couponsList: l,
  qtdCouponsView: w
}) => {
  const [L, C] = e(!0), [q, p] = e([]), [u, c] = e("coupons-view"), [D, y] = e(!1), [N, d] = e(!1), [v, R] = e(""), [m, V] = e(""), [J, x] = e(
    !A
  ), [b, k] = e();
  return S(() => {
    n && R(n);
  }, [n]), S(() => {
    (async () => {
      C(!0);
      try {
        const i = await E(f, j, l);
        if (w) {
          const z = i.slice(0, w);
          p(z);
          return;
        }
        p(i);
        return;
      } catch (i) {
        p([]);
      } finally {
        C(!1);
      }
    })();
  }, [JSON.stringify(l)]), L ? /* @__PURE__ */ t("div", { className: "coupons-container", children: /* @__PURE__ */ t(
    G,
    {
      isIO: o,
      closeIOModal: r,
      genericTaggingEvent: s
    }
  ) }) : /* @__PURE__ */ B("div", { className: "coupons-container", children: [
    (!o || o && u === "coupons-view") && /* @__PURE__ */ t(
      H,
      {
        orderFormId: h,
        hasItemsInCart: a,
        account: f,
        isIO: o,
        closeIOModal: r,
        coupons: q,
        firstCouponName: v,
        secondCouponName: m,
        replaceCoupon: N,
        setView: c,
        setFirstCouponName: R,
        setSecondCouponName: V,
        setActiveRule: y,
        setDataItem: k,
        setReplaceCoupon: d,
        setIsCloseModalEmpty: x,
        genericTaggingEvent: s
      }
    ),
    (!o || o && u === "rules-view") && D && /* @__PURE__ */ t(
      K,
      {
        dataItem: b,
        setActiveRule: y,
        setView: c,
        isIO: o,
        closeIOModal: r,
        genericTaggingEvent: s
      }
    ),
    (!o || o && u === "overwrite-view") && m && !N && /* @__PURE__ */ t(
      P,
      {
        firstCouponName: v,
        secondCouponName: m,
        setView: c,
        setReplaceCoupon: d,
        setSecondCouponName: V,
        isIO: o,
        closeIOModal: r,
        genericTaggingEvent: s
      }
    ),
    !a && J && /* @__PURE__ */ t(
      Q,
      {
        setIsCloseModalEmpty: x,
        genericTaggingEvent: s
      }
    )
  ] });
};
export {
  I as Coupons
};
